import { DeathDataForm } from 'cancellations/view-models/cancellation-due-death';
import { DateTime } from 'luxon';
import { ActType } from 'shell/constants/act-type';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import { DatiAggiuntiviSide, ModelEventoDTO } from 'shell/models/act-category-list';

export const transformDeathDataForm = (
  modelEventoDTO: ModelEventoDTO,
  datiAggiuntiviSide: DatiAggiuntiviSide
): DeathDataForm => {
  const datiDiMorte = datiAggiuntiviSide.datiDiMorteTranscod || {};

  // estero
  const happenInItaly = datiDiMorte.idStatoMorte !== CODE_STATE_ITALIAN;
  return {
    eventDate: datiDiMorte.dataMorte
      ? { date: DateTime.fromISO(datiDiMorte.dataMorte), type: ['day', 'month', 'year'] }
      : datiDiMorte?.dataPresuntaMorteDa
      ? { date: DateTime.fromISO(datiDiMorte.dataPresuntaMorteDa), type: ['day', 'month', 'year'] }
      : undefined,
    happenInItaly,
    eventItaly: happenInItaly
      ? undefined
      : {
          provinceCode: datiDiMorte.idProvinciaMorte || '',
          province: datiDiMorte.siglaProvinciaMorte || '',
          municipalityDescription: datiDiMorte.nomeComuneMorte || '',
          municipalityId: datiDiMorte.idComuneMorte || '',
        },
    eventForeign: happenInItaly
      ? {
          stateId: datiDiMorte.idStatoMorte || '',
          stateDescription: datiDiMorte.nomeStatoMorte || '',
          istatCode: datiDiMorte.idStatoMorte || '',
          municipalityId: datiDiMorte?.idComuneMorte,
          municipalityDescription: datiDiMorte?.nomeComuneMorte,
          // TODO: non è chiaro il campo da mettere su provincia/contea
          // province: datiDiMorte?.siglaProvinciaMorte,
        }
      : undefined,
    actType: ActType.AttoDigitale,
    digital: {
      documentDate: modelEventoDTO.dataformazione
        ? DateTime.fromISO(modelEventoDTO.dataformazione)
        : null,
      istatCode: datiAggiuntiviSide.idComuneRegistrazione || '',
      municipality: datiAggiuntiviSide.idComuneRegistrazione
        ? {
            id: datiAggiuntiviSide.idComuneRegistrazione || '',
            description: datiAggiuntiviSide.nomeComuneRegistrazione || '',
            idProvince: datiAggiuntiviSide.idProvinciaRegistrazione
              ? Number.parseInt(datiAggiuntiviSide.idProvinciaRegistrazione, 10)
              : undefined,
            province: datiAggiuntiviSide.siglaProvinciaRegistrazione || '',
          }
        : undefined,
      idAnsc: modelEventoDTO.idAnsc,
      year: modelEventoDTO.idAnsc ? modelEventoDTO.idAnsc.split('-')[0] : '',
      nationalNumber: modelEventoDTO.idAnsc ? modelEventoDTO.idAnsc.split('-')[1] : '',
      numberMunicipality: modelEventoDTO.idAnsc ? modelEventoDTO.idAnsc.split('-')[2] : '',
    },
  };
};
